import React, { useEffect } from "react";
import "./styled.css";
//redux
import { connect } from "react-redux";
//service
import { setAdminPlusRankingPoints } from "../../../../utils/service/ranking";

import ReactYT from "react-youtube";

function Diversity(props) {
  function pointAction(type) {
    setAdminPlusRankingPoints(
      type,
      props.state.user.registration,
      "c90a159e-e538-43d3-a66b-82292586912f"
    );
  }

  useEffect(() => {
    document.getElementById("title-diversity").focus();
  }, []);
  return (
    <section className="section-diversity">
      <a id="title-diversity" className="title-home" tabIndex={12}>
        Página Expo Área - Diversidade e Inclusão
      </a>
      <div className="div-cards-diversity">
        <div className="card-diversity">
          <a
            className="title-card-diversity"
            id="title-card-diversity"
            tabIndex={13}
          >
            Diversidade
          </a>
          <video
            tabIndex={14}
            controls
            width={200}
            height={200}
            onPlay={() => pointAction("DIVERSIDADEEINCLUSAOVIDEODIVERSIDADE")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/EXPO/STAND%20-%20DIVERSIDADE%20E%20INCLUS%C3%83O/Diversidade.mp4" />
          </video>
        </div>

        <div className="card-diversity">
          <a className="title-card-diversity" tabIndex={15}>
            Censo
          </a>
          <video
            tabIndex={16}
            controls
            width={200}
            height={200}
            onPlay={() => pointAction("DIVERSIDADEEINCLUSAOVIDEOCENSO")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/EXPO/STAND%20-%20DIVERSIDADE%20E%20INCLUS%C3%83O/V%C3%ADdeo%20Censo.mp4" />
          </video>
        </div>

        <div className="card-diversity">
          <a className="title-card-diversity" tabIndex={15}>
            Vídeo Renata Araujo
          </a>
          <video
            tabIndex={16}
            controls
            width={200}
            height={200}
            onPlay={() => pointAction("DIVERSIDADEEINCLUSAOVIDEOTOMAZ")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/AREA%20EXPO/stand_diversidades/%C3%81reas%20Expo%20-%20Diversidade%20e%20Inclus%C3%A3o%20%28Renata%20Araujo%29%20V2023%20%283%29.mp4" />
          </video>
        </div>

        {/* <div className="card-diversity">
          <a className="title-card-diversity" tabIndex={17}>
            Diversidade
          </a>
          <ReactYT
            tabIndex={18}
            videoId="04k7mKheWK0"
            onPlay={() => pointAction("ESTANDE3")}
          />
        </div> */}

        {/* <div className="card-diversity">
          <a className="title-card-diversity" tabIndex={19}>
            Mulheres na ciência e tecnologia
          </a>
          <ReactYT tabIndex={20} videoId="TWYoIBy37sI" />
        </div> */}
      </div>
    </section>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(Diversity);
